/* eslint-disable spire/export-styles */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    currentPage: getCurrentPage(state),
});

type Props = WidgetProps & HasCategoryContext & ReturnType<typeof mapStateToProps>;

// interface Props extends WidgetProps, HasCategoryContext {}

export interface BannerStyles {
    bannerStyle?: InjectableCss;
}

export const bannerStyles: BannerStyles = {
    bannerStyle: {
        css: css`
            background-position: center;
            background-size: cover;
            height: 130px;
            display: flex;
            align-items: flex-start;
            position: relative;
            justify-content: center;
            text-align: center;
            background-image: url(/userfiles/images/banner/title_bg.png);
            h2,
            h1 {
                align-self: center;
                text-transform: uppercase;
                font-size: 20px;
                color: #ffffff;
                line-height: 20px;
                font-weight: 600;
                padding: 20px;
            }
            @media print {
                display: none !important;
            }
        `,
    },
};

const styles = bannerStyles;

const CategoryImage: React.FunctionComponent<Props> = ({ category, currentPage }: Props) => {
    if (!category) {
        return null;
    }

    const isSearchCrawler = getIsWebCrawler();

    return (
        <StyledWrapper {...styles.bannerStyle}>
            <Typography
                as="h1"
                variant={isSearchCrawler && currentPage.type === "CategoryDetailsPage" ? "h1" : "h2"}
                data-test-selector={`categoryName_${category.shortDescription ?? category.name}`}
            >
                {category.shortDescription ?? category.name}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withCategory(CategoryImage)),
    definition: {
        group: "Category Details",
        icon: "folder-bookmark",
        // allowedContexts: ["CategoryDetailsPage", "ProductDetailsPage", "ProductListPage"],
    },
};

export default widgetModule;
